export const ADD_NEW_SECTOR = 'addNewSector';
